<div class="player-menu">
    <div class="reply-btn" *ngIf="playMode == 'replay'">
        <app-date-picker [startDate]="startDate.toISOString()" [min]="project().createdDate"
            (dateChanged)="onPickerChanged($event)"></app-date-picker>
    </div>

    <div id="player" class="player text-center player-group" *ngIf="playMode == 'replay'">
        <lib-button id="button_fbw" color="none" textColor="primary" icon="skip_previous" (click)="onReward()"
            [tooltip]="'planning.player.skip_previous' | translate">
        </lib-button>

        <lib-button id="button_bw" color="none" textColor="primary" icon="fast_rewind" (click)="onRewardHold()"
            [tooltip]="'planning.player.rewind' | translate">
        </lib-button>

        <lib-button id="button_play" color="none" textColor="primary" icon="play_arrow" (click)="onPlay()"
            [tooltip]="'planning.player.play' | translate" *ngIf="playerState !== 'play' && playerState !== 'pause'">
        </lib-button>

        <lib-button id="button_play" color="none" textColor="tertiary" icon="play_arrow" (click)="onPlay()"
            [tooltip]="'planning.player.resume' | translate" *ngIf="playerState == 'pause'">
        </lib-button>

        <lib-button id="button_play" color="none" textColor="secondary" icon="pause_circle_filled" (click)="onPlay()"
            [tooltip]="'planning.player.pause' | translate"
            *ngIf="this.playerState == 'play' || this.playerState == 'resume'">
        </lib-button>

        <lib-button id="button_stop" color="none" [textColor]="playerState == 'stop' ? 'muted' : 'danger'" icon="stop"
            (click)="stop()" [tooltip]="'planning.player.stop' | translate">
        </lib-button>

        <lib-button id="button_fw" color="none" textColor="primary" icon="fast_forward" (click)="onForwardHold()"
            [tooltip]="'planning.player.forward' | translate">
        </lib-button>

        <lib-button id="button_ffw" color="none" textColor="primary" icon="skip_next" (click)="onForward()"
            [tooltip]="'planning.player.skip_next' | translate">
        </lib-button>
    </div>
</div>

<div id="eventText"></div>